import { trackDeliveryMethodSelected } from '@/utils/checkoutAnalytics'
import { getMissingAddressFields } from '@/utils/validation.js'

// Миксин читает у компонента activeDeliveryType, fieldsConfig и addressInfo.PROFILE.
export default {
  data() {
    return {
      deliveryAnalytics: {
        addressFromSuggest: false,
        pendingAddressSource: null,
      },
    }
  },
  methods: {
    markAddressFromSuggest() {
      this.deliveryAnalytics.addressFromSuggest = true
      this.deliveryAnalytics.pendingAddressSource = null
    },

    cancelAddressPending() {
      this.deliveryAnalytics.pendingAddressSource = null
    },

    resetAddressAnalytics() {
      this.deliveryAnalytics.addressFromSuggest = false
      this.deliveryAnalytics.pendingAddressSource = null
    },

    reportDeliveryPrefill(deliveryId) {
      // После выбора подсказки адрес уже не из профиля —
      // автовыбор способа при перезапросе /delivery не помечаем как prefill.
      if (!deliveryId || this.deliveryAnalytics.addressFromSuggest) return

      trackDeliveryMethodSelected({
        source: 'prefill',
        trigger: 'auto_prefill',
        method: deliveryId,
      })
    },

    onManualAddressChange(fieldName) {
      if (!this.isRequiredAddressField(fieldName)) return

      this.deliveryAnalytics.addressFromSuggest = false
      this.reportAddressSourceOrWait('manual_input')
    },

    reportSuggestDeliverySelected() {
      this.reportAddressSourceOrWait('validated_suggest')
    },

    reportAddressSourceOrWait(source) {
      this.deliveryAnalytics.pendingAddressSource = null
      const isReported = this.reportAddressDeliverySelected(source)
      if (!isReported) {
        this.deliveryAnalytics.pendingAddressSource = source
      }
    },

    onPostindexApplied() {
      const source = this.deliveryAnalytics.pendingAddressSource
      if (!source) return

      this.deliveryAnalytics.pendingAddressSource = null
      this.reportAddressDeliverySelected(source)
    },

    isRequiredAddressField(fieldName) {
      const field = this.fieldsConfig?.ADDRESS_INFO_FIELDS?.find(
        (item) => item.name === fieldName
      )
      return Boolean(field?.required)
    },

    reportAddressDeliverySelected(source) {
      const deliveryId = this.activeDeliveryType?.ID
      if (!deliveryId) return false

      const missingFields = getMissingAddressFields(
        this.fieldsConfig,
        this.addressInfo.PROFILE
      )
      if (missingFields.length) return false

      trackDeliveryMethodSelected({
        source,
        trigger: 'user_action',
        method: deliveryId,
      })
      return true
    },
  },
}
